'use client';

import React from 'react';
import { Award, CheckCircle2, Circle } from 'lucide-react';

interface AssessmentPanelProps {
  assessment: string;
  isPassed: boolean;
  onToggle: () => void;
}

export default function AssessmentPanel({ assessment, isPassed, onToggle }: AssessmentPanelProps) {
  return (
    <div
      style={{
        backgroundColor: 'var(--bg-card)',
        border: `1px solid ${isPassed ? 'var(--accent-border)' : 'var(--border)'}`,
        borderRadius: '12px',
        padding: '20px',
        transition: 'border-color 150ms ease',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '16px' }}>
        <div style={{ flex: 1 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginBottom: '10px',
            }}
          >
            <Award size={16} style={{ color: isPassed ? 'var(--accent)' : 'var(--text-muted)' }} />
            <span
              style={{
                fontSize: '11px',
                fontFamily: 'IBM Plex Mono, monospace',
                fontWeight: 600,
                color: 'var(--text-muted)',
                letterSpacing: '0.06em',
              }}
            >
              WEEKLY ASSESSMENT
            </span>
            {isPassed && (
              <span
                style={{
                  fontSize: '11px',
                  fontFamily: 'IBM Plex Mono, monospace',
                  color: 'var(--accent)',
                  backgroundColor: 'var(--accent-glow)',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  border: '1px solid var(--accent-border)',
                }}
              >
                PASSED
              </span>
            )}
          </div>
          <p
            style={{
              fontSize: '14px',
              color: 'var(--text-primary)',
              lineHeight: 1.6,
              margin: 0,
            }}
          >
            {assessment}
          </p>
        </div>

        <button
          onClick={onToggle}
          aria-label={isPassed ? 'Mark assessment as not passed' : 'Mark assessment as passed'}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 16px',
            borderRadius: '8px',
            border: `1px solid ${isPassed ? 'var(--accent)' : 'var(--border)'}`,
            backgroundColor: isPassed ? 'var(--accent)' : 'var(--bg-elevated)',
            color: isPassed ? '#fff' : 'var(--text-secondary)',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: 600,
            transition: 'all 150ms ease',
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
          onMouseEnter={e => {
            if (!isPassed) {
              (e.currentTarget as HTMLElement).style.borderColor = 'var(--accent-border)';
              (e.currentTarget as HTMLElement).style.color = 'var(--accent)';
            }
          }}
          onMouseLeave={e => {
            if (!isPassed) {
              (e.currentTarget as HTMLElement).style.borderColor = 'var(--border)';
              (e.currentTarget as HTMLElement).style.color = 'var(--text-secondary)';
            }
          }}
        >
          {isPassed ? <CheckCircle2 size={15} /> : <Circle size={15} />}
          {isPassed ? 'Mark Unpassed' : 'Mark as Passed'}
        </button>
      </div>
    </div>
  );
}